import AdvertisingOptionState from './AdvertisingOptionState';
import { createStore } from 'satcheljs';

export default createStore<AdvertisingOptionState>('adsPrefsOptionStore', {
    allowConsent: null,
    allowAccess: null,
    allowAdSelection: null,
    allowContentSelection: null,
    allowMeasurement: null,
    allowPersonalization: null,
    showGdprPartnerListView: false,
    vendorList: null,
    markOptionFormDirty: false,
});
